import styled from '@emotion/styled';

export const SingleBetName = styled('div', { label: 'SingleBetName' })`
    display: flex;
    font-size: 14px;
    line-height: 1.29;
    margin-bottom: 1px;
    padding: 0 6px 0 2px;
`;

export const SingleBetNameInfo = styled('div', { label: 'SingleBetNameInfo' })`
    font-size: 10px;
    line-height: 1.4;
    display: flex;
    color: #767676;
    margin-left: 20px;
`;

export const BetNameWrapper = styled('div', { label: 'BetNameWrapper' })`
    display: inherit;
`;
export const InputAndBetNameWrapper = styled('div', { label: 'InputAndBetNameWrapper' })`
    display: flex;
    flex-direction: row;
`;
